import { Button, Grid, useDisclosure } from '@chakra-ui/react'
import { InsuranceParamsPropertyDto, OfferProperty } from 'BrokerTsLib/src/dtos'
import { RiskVariant } from 'BrokerTsLib/src/enums'

import { Container } from '../../components/Container'
import { Loading } from '../../components/Loading'
import { usePropertyOffersContext } from '../../context/PropertyOffersProvider'
import { baseUrl } from '../../hooks'
import { useUpdateInsuranceStartDate } from '../../hooks/useWizard'
import { Duplicate } from '../../icons'
import { useInsuranceParamsContext } from '../../layouts/Wizard'
import { NewInsuranceVariantWrapper } from '../chaloupka/NewInsuranceVariantWrapper'
import { ExtraInsurancePropertyModal } from '../ExtraInsurancePropertyModal'
import { FormButtons } from '../FormButtons'
import { OfferPropertyGrid } from './grid/OfferPropertyGrid'
import { OffersToolbar } from './OffersToolbar'

const insuranceParamsApiUrl = process.env.REACT_APP_INSURANCEPARAMSPROPERTY_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`

export const OfferPropertyCompare = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useInsuranceParamsContext()
  const insuranceParamsProperty = insuranceParams as InsuranceParamsPropertyDto
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { offers, recalculateOffers, showAll, setShowAll, sortBy, setSortBy: changeSortBy, isLoading, updateOffer } = usePropertyOffersContext()
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)

  // seskupování podle domácnost / stavba / domácnost a stavba -> ne podle jednotlivých variant
  const variantsHoushold = insuranceParamsProperty.property.variants?.filter(v => v.variantParts?.some(vp => vp.riskVariant == RiskVariant.Household))
  const variantsRealty = insuranceParamsProperty.property.variants?.filter(v => v.variantParts?.some(vp => vp.riskVariant == RiskVariant.Realty))
  const variantsHousholdAndRealty = insuranceParamsProperty.property.variants?.filter(v => v.variantParts?.some(vp => vp.riskVariant == RiskVariant.HouseholdAndRealty))

  const loadingOffers = (!offers || offers.length == 0) && isLoading
  return (
    <Grid sx={{ gap: 8 }}>
      <Container>
        <OffersToolbar
          offers={offers}
          editable={!insuranceParams?.generalParams.contractNumber}
          showAll={showAll}
          onSettingsClick={onOpen}
          setShowAll={setShowAll}
          onSetStartDate={(date: Date) => {
            return updateInsuranceStartDate(date)
              .then(() => {
                recalculateOffers()
                refetchInsuranceParams() // aby se updatnul header
              })
          }}
          sortBy={sortBy}
          changeSortBy={(sortBy) => changeSortBy(sortBy)}
          updateOffer={(offer) => updateOffer(offer as OfferProperty)}
        />
      </Container>
      {loadingOffers && <Loading large={true} />}
      {!loadingOffers && variantsHoushold && variantsHoushold.length > 0 &&
        <OfferPropertyGrid key={RiskVariant.Household} variants={variantsHoushold} icon='household' />
      }
      {!loadingOffers && variantsRealty && variantsRealty.length > 0 &&
        <OfferPropertyGrid key={RiskVariant.Realty} variants={variantsRealty} icon='property' />
      }
      {!loadingOffers && variantsHousholdAndRealty && variantsHousholdAndRealty.length > 0 &&
        <OfferPropertyGrid key={RiskVariant.HouseholdAndRealty} variants={variantsHousholdAndRealty} icon='householdProperty' />
      }
      
      {insuranceParams &&
        <>
          <Container>
            {!isContracted && <NewInsuranceVariantWrapper />}

            <FormButtons
              leftButtons={
                <Button variant="outline"
                  as='a'
                  href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(`${baseUrl}/chaloupka/wizard/1`)}`}
                >
                  <Duplicate color="secondary.500" />
                  Klonovat
                </Button>
              }
            />
          </Container>

          <ExtraInsurancePropertyModal isOpen={isOpen} onClose={onClose} />
        </>
      }

    </Grid>
  )
}
